import { Grid2 } from '@aibees/shared/components';
import { useMount } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { memo } from 'react';
import Chart, { useChart } from '../api-panel-chart';
import * as SX from './sx';
import type { UsageAnalyticsChartProps as Props } from './types';

export const ApiUsageAnalyticsChart = memo(
  ({ className, title, chart, loading, sx }: Props) => {
    const { colors, categories, series, options } = chart;

    const chartOptions = useChart({
      colors,
      noData: {
        text: loading ? 'Loading...' : 'No data was found.',
      },

      legend: {
        position: 'top',
        horizontalAlign: 'right',
      },
      xaxis: {
        categories,
      },
      stroke: {
        width: 3,
      },
      ...options,
      yaxis: [
        {
          show: true,
        },
        {
          show: false,
        },
      ],
    });

    useMount(() => {
      window.dispatchEvent(new Event('resize'));
    });

    return (
      <Card
        className={classnames('ApiUsageAnalyticsChart', className)}
        sx={SX.root}
        variant="outlined"
      >
        <CardContent>
          <Grid2 xs={48}>
            <Typography variant="body2" color="black" fontWeight={700}>
              {title}
            </Typography>
          </Grid2>

          <Grid2 xs={48} sx={SX.gridChart}>
            <Box sx={SX.boxChart}>
              <Chart
                dir="ltr"
                type="area"
                series={series.data}
                options={chartOptions}
                height="100%"
                width="100%"
              />
            </Box>
          </Grid2>
        </CardContent>
      </Card>
    );
  }
);

ApiUsageAnalyticsChart.displayName = 'ApiUsageAnalyticsChart';
